import { all, post, spread } from 'axios';
import { encodeFormData } from '../../helpers/encode-form-data';

const { console, price, productCode } = window;

export default {
  el: '#main',
  data: {
    form: {
      first_name: '',
      email: '',
      URL: '',
      price,
      productCode,
      applyCredits: false,
      phoneNumber: '',
      billing: 'Bill Volusion account'
    },
    views: {
      thankyou: false
    }
  },
  methods: {
    showThankYou() {
      this.views.thankyou = true;
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    },
    checkboxToggle() {
      this.applyCredits = !this.applyCredits;
    },
    validateForm(e) {
      e.preventDefault();

      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.views.email = true;
          return false;
        }

        this.sendServices();
        this.sendPardot();
        this.showThankYou();
      });
    },
    sendPardot() {
      const firstName = this.form.first_name
        .split(' ')
        .slice(0, -1)
        .join(' ');
      const lastName = this.form.first_name
        .split(' ')
        .slice(-1)
        .join(' ');

      const pardotObject = {
        email: this.form.email,
        phone: Number(this.form.phoneNumber),
        first_name: firstName,
        last_name: lastName,
        list_price: this.form.price,
        product_code: this.form.productCode,
        store_url: this.form.URL,
        apply_credits: this.form.applyCredits,
        payment_method: this.form.billing
      };

      return post(
        'https://go.pardot.com/l/513691/2019-04-22/8zh4ld',
        pardotObject, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: '*/*'
          },
          withCredentials: true,
          transformRequest: [encodeFormData]
        }
      );
    },
    sendServices() {
      return post(
        'https://mrkt-api-mailchimp.appspot.com/api/v2/quickwins',
        this.form
      );
    }
  }
};